// extracted by mini-css-extract-plugin
module.exports = {"base":"fourStoryHalfFeatured-m__base__lPuPL","featured-storycard":"fourStoryHalfFeatured-m__featured-storycard__1IBwk"};